var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "s-charts" }, [
    _c("div", { staticClass: "s-charts-items s-charts-items_active" }, [
      _c(
        "div",
        { staticClass: "s-chart s-chart_dynamic" },
        [
          _c("c-switcher", {
            staticClass: "s-chart-switcher",
            attrs: {
              type: "group",
              items: [
                { icon: "ruble", value: "ruble" },
                { icon: "percent", value: "percent" },
              ],
            },
            model: {
              value: _vm.dynamicsChart.switcher,
              callback: function ($$v) {
                _vm.$set(_vm.dynamicsChart, "switcher", $$v)
              },
              expression: "dynamicsChart.switcher",
            },
          }),
          _c("highcharts", {
            staticClass: "s-chart-chart",
            attrs: { options: _vm.dynamicsChart.options },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "s-chart s-chart_branches" },
        [
          _c("c-switcher", {
            staticClass: "s-chart-switcher",
            attrs: {
              type: "group",
              items: [
                { icon: "ruble", value: "ruble" },
                { icon: "percent", value: "percent" },
              ],
            },
            model: {
              value: _vm.branchesChart.switcher,
              callback: function ($$v) {
                _vm.$set(_vm.branchesChart, "switcher", $$v)
              },
              expression: "branchesChart.switcher",
            },
          }),
          _c("highcharts", {
            staticClass: "s-chart-chart",
            attrs: { options: _vm.branchesChart.options },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "s-chart s-chart_pie flex-grow-1" },
        [
          _c("highcharts", {
            staticClass: "s-chart-chart",
            attrs: { options: _vm.positionsChart.options },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }